import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  materialsList: [],
  organizationData: [],
  currencyData: [],
  bankData: {},
  shapeCutsList: [],
  metalCaratTypesList: [],
  productsList: [],
  productColorList: [],
  musharkaDuration: [],
  riskLevel: [],
  stoneClarity: [],
  musharakahMaterialsList: [],
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    addMaterials: (state, action) => {
      const { data } = action.payload;
      state.materialsList = data;
    },
    addGeneralData: (state, action) => {
      const { data } = action.payload;
      state.organizationData = data;
    },
    addCurrencyData: (state, action) => {
      const { data } = action.payload;
      state.currencyData = data;
    },
    addBankData: (state, action) => {
      const { data } = action.payload;
      state.bankData = data;
    },
    addShapeCuts: (state, action) => {
      const { data } = action.payload;
      state.shapeCutsList = data;
    },
    addMetalCaratTypes: (state, action) => {
      const { data } = action.payload;
      state.metalCaratTypesList = data;
    },
    addProductType: (state, action) => {
      const { data } = action.payload;
      state.productsList = data;
    },
    addProductColor: (state, action) => {
      const { data } = action.payload;
      state.productColorList = data;
    },
    addMusharkaDuration: (state, action) => {
      const { data } = action.payload;
      state.musharkaDuration = data;
    },
    addRiskLevel: (state, action) => {
      const { data } = action.payload;
      state.riskLevel = data;
    },
    addStoneClarity: (state, action) => {
      const { data } = action.payload;
      state.stoneClarity = data;
    },
    addMusharakahMaterials: (state, action) => {
      const { data } = action.payload;
      state.musharakahMaterialsList = data;
    },
  },
});

export default settingsSlice;
export const {
  addMaterials,
  addGeneralData,
  addCurrencyData,
  addBankData,
  addShapeCuts,
  addMetalCaratTypes,
  addProductType,
  addProductColor,
  addMusharkaDuration,
  addRiskLevel,
  addStoneClarity,
  addMusharakahMaterials,
} = settingsSlice.actions;
